import {
  buildAuthRedirectUrl,
  type AuthRedirectKind,
  type BuildAuthRedirectOptions,
} from '@kairos/lib/auth/redirect-urls'

/**
 * CASA 2.4 — the admin SPA's single source of auth redirect targets.
 *
 * The admin app is a Vite build, so the site URL comes from `import.meta.env`.
 * In production (`import.meta.env.PROD`) the page origin is ignored entirely:
 * `window.location.origin` used to leak `http://localhost:5173` from the local
 * dev server and the `*.workers.dev` / `*.pages.dev` preview host, neither of
 * which is on the Supabase allow-list.
 */
function adminAuthEnv(): Pick<BuildAuthRedirectOptions, 'siteUrl' | 'isProduction' | 'clientOrigin'> {
  return {
    siteUrl: import.meta.env.VITE_SITE_URL ?? import.meta.env.NEXT_PUBLIC_SITE_URL,
    isProduction: import.meta.env.PROD,
    clientOrigin: typeof window === 'undefined' ? undefined : window.location.origin,
  }
}

export function adminAuthRedirect(
  kind: AuthRedirectKind,
  options: BuildAuthRedirectOptions = {},
): string {
  return buildAuthRedirectUrl('admin', kind, {
    ...adminAuthEnv(),
    ...options,
  })
}
